/*
 * File: src/components/OutstandingOrders/ExportOutstandingOrders.jsx
 * Purpose: Exports the current Outstanding Orders list as CSV from the all-reps endpoint.
 */

import React from 'react';
import PropTypes from 'prop-types';

import ExportButton from '../ExportButton.jsx';

function ExportOutstandingOrders({ searchText }) {
  const url = '/api/outstanding-orders/all-reps';
  const filename = 'outstanding-orders-all-reps.csv';

  const params = new URLSearchParams();
  if (searchText) {
    params.append('search', searchText);
  }
  const fullUrl = params.toString() ? `${url}?${params.toString()}` : url;

  return (
    <ExportButton
      url={fullUrl}
      filename={filename}
      data-cy="export-outstanding-orders-button"
      buttonText="Export"
    />
  );
}

ExportOutstandingOrders.propTypes = {
  searchText: PropTypes.string,
};

ExportOutstandingOrders.defaultProps = {
  searchText: '',
};

export default React.memo(ExportOutstandingOrders);
